<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="6">
          <span>INSCRIPCIONES PRODUCTIVIDAD</span>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-form ref="formulario" @submit.prevent="obtenerDatos">
      <v-row dense>
        <v-col cols="12" md="6" lg="3">
          <v-menu
            ref="menu"
            v-model="menuRangoFechas"
            :close-on-content-click="false"
            :return-value.sync="rangoFechas"
            transition="scale-transition"
            offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="rangoFechas"
                label="Rango de Fechas"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                :disabled="cargando"
                :rules="[
                  (valor) => valor?.length === 2 || 'El rango de fechas es obligatorio',
                  (valor) => {
                    if (valor?.length !== 2) return true;
                    const diff = (new Date(valor[1]) - new Date(valor[0])) / (1000 * 60 * 60 * 24);
                    return diff <= 31 || 'El rango no puede superar los 31 días';
                  },
                ]"
                required
                outlined
                dense
                clearable></v-text-field>
            </template>

            <v-date-picker
              v-model="rangoFechas"
              locale="es-ES"
              :max="fechaDeHoy()"
              :disabled="cargando"
              range
              no-title
              scrollable
              @input="
                rangoFechas?.length === 2 &&
                  (new Date(rangoFechas[1]) - new Date(rangoFechas[0])) / (1000 * 60 * 60 * 24) <= 31 &&
                  $refs.menu.save(rangoFechas)
              ">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="6" lg="3">
          <v-select
            v-model="unidadNegocioSeleccionadaId"
            :items="unidadesNegocios"
            item-text="nombre"
            item-value="id"
            label="Unidad de Negocio"
            :disabled="cargando"
            :rules="[(valor) => !!valor || 'La unidad de negocio es obligatoria']"
            required
            outlined
            dense
            @change="obtenerSedesPorUnidadesNegociosIds" />
        </v-col>

        <v-col cols="12" md="6" lg="3">
          <v-select
            v-model="sedeSeleccionadaId"
            :items="sedesPorUnidadNegocio"
            item-text="nombre"
            item-value="id"
            label="Sede"
            :disabled="cargando || sedesPorUnidadNegocio.length === 0 || !unidadNegocioSeleccionadaId"
            required
            outlined
            dense
            clearable
            hide-details />
        </v-col>

        <v-col cols="12" md="6" lg="3">
          <div class="d-flex flex-wrap align-center" style="gap: 8px">
            <v-btn class="mx-1" title="Consultar" type="submit" small color="primary" :disabled="cargando">
              <v-icon left>mdi-magnify</v-icon> Consultar
            </v-btn>

            <v-btn
              class="mx-1"
              title="Exportar a Excel"
              type="button"
              small
              color="primary"
              :disabled="exportandoAExcel"
              :loading="exportandoAExcel"
              @click="exportarAExcel">
              <v-icon left>mdi-file-excel</v-icon> Exportar
            </v-btn>

            <v-switch
              style="margin-top: -4px"
              title="Mostrar pagos"
              v-model="mostradoPagos"
              :disabled="cargando"
              dense
              hide-details
              label="Mostrar pagos"></v-switch>
          </div>
        </v-col>
      </v-row>
    </v-form>

    <v-row dense>
      <v-col cols="12">
        <v-tabs v-model="tab" @change="onchangeTab">
          <v-tab>Detalle de Inscripciones</v-tab>
          <v-tab>Inscripciones por Sedes</v-tab>
          <v-tab>Inscripciones por Asesores</v-tab>
          <v-tab>Gráficos</v-tab>

          <v-tab-item :transition="false">
            <ListadoInscripcionesCompletas
              ref="listadoRef"
              :rowData="items"
              :cargando="cargando"
              @seleccionarItem="seleccionarItem" />
          </v-tab-item>

          <v-tab-item :transition="false">
            <TablaInscripcionesCompletasConsolidadas
              :inscripcionesPorSedes="inscripcionesPorSedes"
              :programasConInscripciones="programasConInscripciones"
              :cargando="cargando" />
          </v-tab-item>

          <v-tab-item :transition="false">
            <TablaInscripcionesCompletasPorAsesores
              :inscripcionesPorAsesores="inscripcionesPorAsesores"
              :cargando="cargando" />
          </v-tab-item>

          <v-tab-item :transition="false">
            <GraficosInscripcionesCompletas
              ref="graficosInscripcionesCompletasRef"
              :inscripcionesPorSedes="inscripcionesPorSedes"
              :inscripcionesPorAsesores="inscripcionesPorAsesores"
              :cargando="cargando"
              :rangoFechas="rangoFechas" />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ListadoInscripcionesCompletas from './components/ListadoInscripcionesCompletas.vue';
import inscripcionesService from '../services/inscripciones.service';
import sedesService from '../services/sedes.service';
import programaService from '../services/programas.service';
import TablaInscripcionesCompletasConsolidadas from './components/TablaInscripcionesCompletasConsolidadas.vue';
import { fechasDesdeHasta } from '../utils/funciones';
import TablaInscripcionesCompletasPorAsesores from './components/TablaInscripcionesCompletasPorAsesores.vue';
import GraficosInscripcionesCompletas from './components/GraficosInscripcionesCompletas.vue';

export default {
  name: 'InscripcionesProductividadLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoInscripcionesCompletas,
    TablaInscripcionesCompletasConsolidadas,
    TablaInscripcionesCompletasPorAsesores,
    GraficosInscripcionesCompletas,
  },
  computed: {
    mostradoPagos: {
      get() {
        return this.$store.state.comision.mostradoPagos;
      },
      set(valor) {
        this.$store.dispatch('comision/setMostradoPagos', valor);
      },
    },
    inscripcionesPorSedes() {
      const inscripcionesPorSedes = [];

      this.items.forEach((inscripcion) => {
        const { sedeId, nombreSede, programaId, nombrePrograma, nombreCategoria, nombreArea, cumplimientoRequisitos } =
          inscripcion;
        const indiceSede = inscripcionesPorSedes.findIndex((item) => item.id == sedeId);

        if (indiceSede === -1) {
          inscripcionesPorSedes.push({
            id: sedeId,
            nombre: nombreSede,
            totalInscripcionesCumplenRequisitos: cumplimientoRequisitos ? 1 : 0,
            totalInscripcionesNoCumplenRequisitos: cumplimientoRequisitos ? 0 : 1,
            programas: [
              {
                id: programaId,
                nombre: nombrePrograma,
                tipo: nombreCategoria,
                area: nombreArea,
                totalInscripcionesCumplenRequisitos: cumplimientoRequisitos ? 1 : 0,
                totalInscripcionesNoCumplenRequisitos: cumplimientoRequisitos ? 0 : 1,
              },
            ],
          });
        } else {
          inscripcionesPorSedes[indiceSede].totalInscripcionesCumplenRequisitos += cumplimientoRequisitos ? 1 : 0;
          inscripcionesPorSedes[indiceSede].totalInscripcionesNoCumplenRequisitos += cumplimientoRequisitos ? 0 : 1;

          const indicePrograma = inscripcionesPorSedes[indiceSede].programas.findIndex(
            (prog) => prog.id === inscripcion.programaId,
          );

          if (indicePrograma === -1) {
            inscripcionesPorSedes[indiceSede].programas.push({
              id: programaId,
              nombre: nombrePrograma,
              tipo: nombreCategoria,
              area: nombreArea,
              totalInscripcionesCumplenRequisitos: cumplimientoRequisitos ? 1 : 0,
              totalInscripcionesNoCumplenRequisitos: cumplimientoRequisitos ? 0 : 1,
            });
          } else {
            inscripcionesPorSedes[indiceSede].programas[indicePrograma].totalInscripcionesCumplenRequisitos +=
              cumplimientoRequisitos ? 1 : 0;
            inscripcionesPorSedes[indiceSede].programas[indicePrograma].totalInscripcionesNoCumplenRequisitos +=
              cumplimientoRequisitos ? 0 : 1;
          }
        }
      });

      return inscripcionesPorSedes;
    },
    inscripcionesPorAsesores() {
      const inscripcionesPorAsesores = [];

      this.items.forEach((inscripcion) => {
        const { id, asesorId, numeroDocumentoAsesor, nombreCompletoAsesor, cumplimientoRequisitos } = inscripcion;
        const indiceAsesor = inscripcionesPorAsesores.findIndex((item) => item.id == asesorId);

        if (indiceAsesor === -1) {
          inscripcionesPorAsesores.push({
            id: asesorId,
            inscripcionId: id,
            numeroDocumentoAsesor,
            nombreCompletoAsesor,
            totalInscripcionesCumplenRequisitos: cumplimientoRequisitos ? 1 : 0,
            totalInscripcionesNoCumplenRequisitos: cumplimientoRequisitos ? 0 : 1,
          });
        } else {
          inscripcionesPorAsesores[indiceAsesor].totalInscripcionesCumplenRequisitos += cumplimientoRequisitos ? 1 : 0;
          inscripcionesPorAsesores[indiceAsesor].totalInscripcionesNoCumplenRequisitos += cumplimientoRequisitos
            ? 0
            : 1;
        }
      });

      return inscripcionesPorAsesores;
    },
  },
  data() {
    return {
      nombreRecurso: 'INTERNACIONALIZACIÓN',
      unidadesNegocios: [
        { id: 1, nombre: 'ESAM (POSTGRADOS)' },
        { id: -1, nombre: 'ESAM (CURSOS)' },
        { id: 2, nombre: 'CCA' },
        { id: 3, nombre: 'CIBERKIDS' },
        { id: 6, nombre: 'CYBERCORP' },
        { id: 10, nombre: 'DIGITAL BUSINESS SCHOOL' },
        { id: 12, nombre: 'CCTP' },
        { id: 14, nombre: 'ISPI' },
        { id: 15, nombre: 'UPI' },
      ],
      unidadesNegociosIdsAsociadas: {
        1: [1, 5],
        '-1': [-1, 5],
        2: [2],
        3: [3],
        6: [6],
        10: [10],
        12: [12],
        14: [14],
        15: [15],
      },
      unidadNegocioSeleccionadaId: null,
      menuRangoFechas: false,
      rangoFechas: [],
      sedesPorUnidadNegocio: [],
      sedeSeleccionadaId: null,
      tab: JSON.parse(localStorage.getItem('tabInternacionalizacion')) || 0,
      programasConInscripciones: [],
      exportandoAExcel: false,
    };
  },
  mounted() {},
  methods: {
    async listar() {
      let servicio = null;
      let nombreRecurso = 'Recurso';

      switch (this.unidadNegocioSeleccionadaId) {
        case 1:
          servicio = inscripcionesService.obtenerInscripcionesPostGradosSigloXX;
          nombreRecurso = 'POSTGRADOS SIGLO XX';
          break;
        case -1:
          servicio = inscripcionesService.obtenerInscripcionesEsamCursos;
          nombreRecurso = 'CURSOS ESAM';
          break;
        case 2:
          servicio = inscripcionesService.obtenerInscripcionesCCA;
          nombreRecurso = 'CCA';
          break;
        case 3:
          servicio = inscripcionesService.obtenerInscripcionesCK;
          nombreRecurso = 'CIBERKIDS';
          break;
        case 6:
          servicio = inscripcionesService.obtenerInscripcionesCyberCorp;
          nombreRecurso = 'CYBERCORP';
          break;
        case 10:
          servicio = inscripcionesService.obtenerInscripcionesPostGradosUAP;
          nombreRecurso = 'POSTGRADOS UNIVERSIDAD AMAZÓNICA DE PANDO';
          break;
        case 12:
          servicio = inscripcionesService.obtenerInscripcionesCCTP;
          nombreRecurso = 'CCTP';
          break;
        case 14:
          servicio = inscripcionesService.obtenerInscripcionesISPI;
          nombreRecurso = 'ISPI';
          break;
        case 15:
          servicio = inscripcionesService.obtenerInscripcionesUPI;
          nombreRecurso = 'UPI';
          break;
        default:
          this.$notify({
            group: 'notifications',
            type: 'error',
            title: 'Error',
            text: 'Servicio no definido para la Unidad de Negocio seleccionada.',
          });
          return;
      }
      const { desde, hasta } = fechasDesdeHasta(this.rangoFechas);

      const opciones = {
        params: {
          desde,
          hasta,
          sedeId: this.sedeSeleccionadaId,
        },
      };

      await this.findAllMixin(
        servicio,
        opciones,
        nombreRecurso,
        () => {
          this.items = [];
          this.itemSeleccionado = null;
          this.cargando = true;
        },
        () => {
          this.cargando = false;
        },
        (datos) => {
          this.items = datos;
        },
        () => {
          this.items = [];
          this.itemSeleccionado = null;
        },
      );
    },
    obtenerDatos() {
      if (!this.$refs.formulario.validate()) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Error',
          text: 'Por favor, complete correctamente el formulario antes de continuar.',
        });
        return;
      }

      this.listar().then(() => {
        this.obtenerProgramasConInscripciones();

        setTimeout(() => {
          this.$refs.graficosInscripcionesCompletasRef?.crearGraficos();
        }, 500);
      });
    },
    fechaDeHoy() {
      const hoy = new Date();
      const mes = hoy.getMonth() + 1;
      const dia = hoy.getDate();
      const anio = hoy.getFullYear();

      const mesString = mes < 10 ? `0${mes}` : mes;
      const diaString = dia < 10 ? `0${dia}` : dia;

      return `${anio}-${mesString}-${diaString}`;
    },
    async obtenerSedesPorUnidadesNegociosIds() {
      if (!this.unidadNegocioSeleccionadaId) {
        this.sedesPorUnidadNegocio = [];
        this.sedeSeleccionadaId = null;

        return;
      }
      const unidadesNegociosIds = this.unidadesNegociosIdsAsociadas[this.unidadNegocioSeleccionadaId] || [
        this.unidadNegocioSeleccionadaId,
      ];

      const opciones = { params: { unidadesNegociosIds } };

      await this.findAllMixin(
        sedesService.findAllByUnidadesNegociosIds,
        opciones,
        'SEDES POR UNIDADES DE NEGOCIOS IDS',
        () => {
          this.sedesPorUnidadNegocio = [];
        },
        null,
        (datos) => {
          this.sedesPorUnidadNegocio = datos;
        },
        () => {
          this.sedesPorUnidadNegocio = [];
        },
      );
    },
    onchangeTab(nuevaPestana) {
      if (nuevaPestana == 3) {
        setTimeout(() => {
          this.$refs.graficosInscripcionesCompletasRef?.crearGraficos();
        }, 500);
      }

      localStorage.setItem('tabInternacionalizacion', JSON.stringify(nuevaPestana));
    },
    async obtenerProgramasConInscripciones() {
      const programasIds = this.items.map((item) => item.programaId);

      if (this.items.length === 0 || programasIds.length === 0) {
        return;
      }

      const programasUnicosIds = [...new Set(programasIds)];

      await this.findAllMixin(
        programaService.findProgramasConInscripciones,
        { params: { programasIds: programasUnicosIds.join(',') } },
        'PROGRAMAS CON INSCRIPCIONES',
        () => {
          this.programasConInscripciones = [];
        },
        null,
        (datos) => {
          this.programasConInscripciones = datos;
        },
        () => {
          this.programasConInscripciones = [];
        },
      );
    },
    async exportarAExcel() {
      if (!this.$refs.formulario.validate()) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Error',
          text: 'Por favor, complete correctamente el formulario antes de continuar.',
        });
        return;
      }

      if (!this.unidadNegocioSeleccionadaId) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Error',
          text: 'Debe seleccionar una Unidad de Negocio para exportar a Excel.',
        });

        return;
      }

      this.exportandoAExcel = true;

      let servicio = null;

      switch (this.unidadNegocioSeleccionadaId) {
        case 1:
          servicio = inscripcionesService.exportarReporteInscripcionesPostGradosSigloXXAExcel;
          break;
        case 2:
          servicio = inscripcionesService.exportarReporteInscripcionesCCAAExcel;
          break;
        case 10:
          servicio = inscripcionesService.exportarReporteInscripcionesPostGradosUAPAExcel;
          break;
        case 14:
          servicio = inscripcionesService.exportarReporteInscripcionesISPIAExcel;
          break;
        case 15:
          servicio = inscripcionesService.exportarReporteInscripcionesUPIAExcel;
          break;
        case -1:
          servicio = inscripcionesService.exportarReporteInscripcionesEsamCursosAExcel;
          break;
        case 3:
          servicio = inscripcionesService.exportarReporteInscripcionesCKAExcel;
          break;
        case 6:
          servicio = inscripcionesService.exportarReporteInscripcionesCyberCorpAExcel;
          break;
        case 12:
          servicio = inscripcionesService.exportarReporteInscripcionesCCTPAExcel;
          break;
        default:
          this.$notify({
            group: 'notifications',
            type: 'error',
            title: 'Error',
            text: 'Servicio no definido para la Unidad de Negocio seleccionada.',
          });
          this.exportandoAExcel = false;
          return;
      }

      const { desde, hasta } = fechasDesdeHasta(this.rangoFechas);
      const opciones = {
        params: {
          desde,
          hasta,
          sedeId: this.sedeSeleccionadaId,
        },
      };

      try {
        const respuesta = await servicio(opciones);
        const data = respuesta.data || respuesta;
        const headers = respuesta.headers || {};
        const contentDisposition = headers['content-disposition'] || '';
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        const fileName = fileNameMatch ? fileNameMatch[1] : 'Inscripciones.xlsx';
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const enlace = document.createElement('a');

        enlace.href = url;
        enlace.setAttribute('download', fileName);
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
        window.URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          type: 'success',
          title: 'Éxito',
          text: 'La exportación a Excel se ha realizado correctamente.',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          type: 'error',
          title: 'Error',
          text: `Ocurrió un error al exportar a Excel: ${error.message}`,
        });
      } finally {
        this.exportandoAExcel = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

/* v-date-picker */
::v-deep .accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}
</style>